import { useSelectedTask } from '../../../../../common/hooks/student/useSelectedTask';
import { useVideoProgress } from '../store/videoPlayerStore';
import { useModuleSelectionState } from '../../../../../common/context/AppStateStore';
import log from '../../../../../common/utils/logger';

interface UseVideoProgressProps {
  resourceId: string;
  readOnly?: boolean;
}

export const usePersistVideoProgress = ({ resourceId, readOnly }: UseVideoProgressProps) => {
  const { task, updateProgress } = useSelectedTask();
  const { selectedModule } = useModuleSelectionState();
  const { courseId, moduleId } = selectedModule ?? {};
  const { position, duration } = useVideoProgress();

  // Save progress to backend
  const persistProgress = async () => {
    if (!task || readOnly || !courseId || !moduleId) return;

    const clipPositionSec = Math.floor(position / 1000);
    const clipLength = Math.floor(duration / 1000);
    const completed = clipPositionSec > (clipLength - 10);

    try {
      await updateProgress.mutate({
        courseId,
        moduleId,
        taskId: task.id,
        resourceId,
        data: {
          completed,
          progress: {
            watchedSeconds: clipPositionSec,
            totalSeconds: clipLength,
          },
        },
      });
    } catch (error) {
      log.error('Error updating progress:', error);
    }
  };

  return {
    persistProgress,
  };
};
